import { makeStyles } from 'tss-react/mui';
import { spacing, colors } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme, _params, classes) => ({
    mediaGalleryCard: {
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        borderRadius: theme.isFlyingFlowers ? '0px' : undefined,
        boxShadow: 'none',
        height: 'auto',
        margin: '0 !important',
        minHeight: 'auto',
        maxHeight: '364px',
        [theme.breakpoints.up('sm')]: {
            maxHeight: '352px',
        },
        [theme.breakpoints.up('md')]: {
            margin: 0,
            maxHeight: '372px',
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: '536px',
            maxHeight: '460px',
        },
        cursor: 'pointer',
    },
    mediaImageContainer: {
        width: '100%',
        position: 'relative',
        height: '184px',
        [theme.breakpoints.up('sm')]: {
            height: '172px',
        },
        [theme.breakpoints.up('md')]: {
            height: '168px !important',
        },
        [theme.breakpoints.up('lg')]: {
            height: '216px !important',
        },
        [theme.breakpoints.up('xl')]: {
            height: '288px !important',
        },
        '& > span:first-child': {
            width: '100% !important',
            height: '100% !important',
        },
        '& img': {
            height: '184px',
            [theme.breakpoints.up('sm')]: {
                height: '172px',
            },
            [theme.breakpoints.up('md')]: {
                height: '168px !important',
            },
            [theme.breakpoints.up('lg')]: {
                height: '216px !important',
            },
            [theme.breakpoints.up('xl')]: {
                height: '288px !important',
            },
        },
    },
    imageContainer: {
        objectFit: 'cover',
    },
    textContent: {
        padding: `12px 12px ${spacing.small} 12px`,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
    },
    mediaGalleryContainer: {
        height: '100%',
        placeContent: 'unset',
        flexDirection: 'column',
    },
    mediaContentInner: {
        margin: 0,
        padding: '16px',
        alignSelf: 'start',
    },
    mediaHeading: Object.assign(Object.assign({}, theme.typography.medium_bold), theme.typographySpacing.medium_bold_sm),
    description: Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.small_regular_sm), { color: colors.grey.grey6 }),
    icon: {
        fontSize: `100px`,
    },
    controlsContainer: {
        backgroundColor: 'transparent',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        [`& .${classes.icon}`]: {
            fontSize: '5rem',
            color: colors.supplementary.white,
            cursor: 'pointer',
            marginRight: 0,
            '& span': {
                fontSize: 'inherit',
            },
        },
    },
    headingContainer: {},
    descriptionContainer: {},
}));
export default useStyles;
